// extracted by css-extract-rspack-plugin
export default {"header":"k3zsQ","row":"K1pql","checkboxColumn":"EKiP4"};